export default __webpack_public_path__ + "static/media/message.34ec3d78.mp3";